const confirmElement = document.querySelector('.js-wishlist-delete-confirm');
const deleteButton = document.querySelector('.js-wishlist-delete-btn');
const deleteForm = document.querySelector('.js-wishlist-delete-form');

if (confirmElement && deleteButton && deleteForm) {
    deleteButton.addEventListener('click', async function () {
        const message = confirmElement.getAttribute('data-message') || '';
        const result = await window.showConfirm(message);
        if (!result) {
            return;
        }

        deleteForm.submit();
    });
}

